import React from 'react';
import Lottie from 'react-lottie';
import WorkLottie from '../../../../lotties/ml-lottie-2.json';
import {ImArrowRight2} from 'react-icons/im'
import '../../AiDept/AiDeptTech/AiDeptTech.css';
import './MlDeptTech.css'

function MlDeptTech ()
{
  
  const lottieAnimation = {
      loop: true,
      autoplay: true,
      animationData: WorkLottie,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
         id:"career-lottie-id" ,
        className:"career-lottie-id"
      }
  };
  return ( 
    <>
      <section className='ai-tech-section container'>
        <div className='ai-tech-content-div'>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <div className='Ml-tech-lottie-div'>
                <Lottie options={lottieAnimation}
                  style={{ height: 350, width: 350 }}
                />
              </div>
            </div>

            <div className='col-md-6 col-12'>
              <div className='ai-tech-div'>
                <h1 className='ai-tech-h1'>Cloudin Labs optimize processes with ML and NLP benefits</h1>

                <ul className='ai-tech-ul'>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Build & deploy scalable ML models</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Distill huge volumes of raw data</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Rapid analysis prediction and processing</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Scale accurate financial predictions and models</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Integrate organization’s framework for data preparation</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Reduce time to answer common queries</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Enable text classification, named entity recognition & sentiment analysis</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
   );
}

export default MlDeptTech;